export enum RoleEnum {
  SUPER_ADMIN = 'super_admin',
  CLUB_ADMIN = 'club_admin',
  CLUB_ANALYST = 'club_analyst',
  CLUB_COACH = 'club_coach',
  CLUB_PLAYER = 'club_player',
  /** Meekijken in een league-omgeving; zie AuthService.wisselOmgeving. */
  LEAGUE_VIEWER = 'league_viewer',
  /** Alleen kijken als account: alles van zijn teams, niets wijzigen of downloaden. */
  CLUB_VIEWER = 'club_viewer',
  /** Bijdragen aan een league-omgeving: wedstrijden aanmaken, uploaden. */
  LEAGUE_EDITOR = 'league_editor',
  /** Tagt voor een taggingteam in wedstrijden van andere clubs (docs/TAGGER-OPDRACHTEN.md). */
  TAGGER = 'tagger',
}
